import { html } from '@shared/utils/rendering/html';
import { ERMPortalUrls } from '../../constants/routing/urls.constants';

const TopbarConfig = {
    logo: html`<div class="erm-logo"></div>`,
    baseUrl: ERMPortalUrls.base,
    options: [],
    account: {},
};

export default TopbarConfig;
